import React, { useEffect, useState } from 'react';
import { MainTitle } from "../Typography/titles";
import styled from 'styled-components';
import tw from 'twin.macro';
import { Reveal } from '../Reveal';
interface Partner {
  logoUrl: string;
  url?: string; // 'url' is optional as it might not be present in all objects
}
const PartnersCard = () => {
  const [partnerLogos, setPartnerLogos] = useState<Partner[]>([]);

  useEffect(() => {
    // Your provided JSON data
    const jsonData =
    [
      {
        "_id": "64fedfc93e7a2e0d69ab835a",
        "name": "partner1",
        "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694424944/ATD_SICAR_sicaal.png",
        "__v": 0,
        "url": "https://www.atb.tn/groupe"
      },
      {
        "_id": "64fedfe33e7a2e0d69ab835c",
        "name": "partner2",
        "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1695637525/image_82_lh2wfg.png",
        "__v": 0,
        "url": "http://www.cdcgestion.tn/"
      },
      {
        "_id": "64fedff63e7a2e0d69ab835e",
        "name": "partner3",
        "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1694424944/SMART_CAPITAL_nn5u7m.png",
        "__v": 0,
        "url": "https://smartcapital.tn/"
      },
      {
        "_id": "64fee0083e7a2e0d69ab8360",
        "name": "partner4",
        "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1695638334/Frame_195_3_rnwask.png",
        "__v": 0,
        "url": "https://www.ebrd.com/fr/home"
      },
      {
        "_id": "64fee01b3e7a2e0d69ab8362",
        "name": "partner5",
        "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1695205315/logo4_vsoifm.png",
        "__v": 0,
        "url": "http://tsi.tn/"
      },
      {
        "_id": "64fee02b3e7a2e0d69ab8364",
        "name": "partner6",
        "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1695207153/Frame_170_2_zjxcxx.png",
        "__v": 0,
        "url": "https://www.hpc-group.com.tn/"
      },
      {
        "_id": "64fee0413e7a2e0d69ab8366",
        "name": "partner7",
        "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1695205315/logo5_d2cp5z.png",
        "__v": 0,
      },
      {
        "_id": "650aca163ab5d5f6c158d256",
        "name": "partner8",
        "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1695638182/Frame_195_2_brcfyy.png",
        "url": "https://www.cap.com.tn/"

      },
      {
        "_id": "650aca3c3ab5d5f6c158d257",
        "name": "partner9",
        "logoUrl": "https://res.cloudinary.com/dec07srhw/image/upload/v1695205728/Frame_170_1_ilo4ys.png",
        "url": "https://www.fluides-services.com/fr/"

      },
      {
        "_id": "650aca783ab5d5f6c158d258",
        "name": "partner10",
        "logoUrl": "data:image/png;base64,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",
        "url":"https://kdfeddersen.com/en"
      }
    ]
          // ... include the rest of your JSON data here
      ;

    // Map the data to the Partner interface
    const extractedData: Partner[] = jsonData.map(partner => ({
      logoUrl: partner.logoUrl,
      url: partner.url || '' // Provide a default value if 'url' is not present
    }));

    setPartnerLogos(extractedData);

  }, []);
  const handleRightClick = (event: React.MouseEvent<HTMLImageElement, MouseEvent>, pdfUrl: string | URL | undefined) => {
    event.preventDefault(); // Prevent the default right-click menu
    window.open(pdfUrl, '_blank'); // Open the PDF URL in a new tab
  };
  const logosRow1 = partnerLogos.slice(0, 5);
  const logosRow2 = partnerLogos.slice(5);

  const handlePartnerClick = (url: string) => {
    window.open(url, '_blank');
  };
  return (
    <div>
      <Reveal>
        <MainTitle titleText="Our Partners" text="Our local and international partners are key to our success" />
      </Reveal>

      <Reveal>
        <StyledContainer className="p-8 bg-white mx-8 md:max-w-3xl md:mx-auto -mt-8">
          <StyledImagesContainer>
            {logosRow1.map((partner, index) => (
              <img
              onContextMenu={(event) => handleRightClick(event, partner.url)} // Add right-click handler here

                src={partner.logoUrl}
                alt={`partner ${index + 1}`}
                className="partner-logo"
                key={index}
                onClick={() => {
                  // Only call handlePartnerClick if url is defined
                  if (partner.url) {
                    handlePartnerClick(partner.url);
                  }
                }}
              />
            ))}
          </StyledImagesContainer>
        </StyledContainer>
      </Reveal>

      <Reveal>
        <StyledContainer className="p-8 bg-white mx-4 md:max-w-3xl md:mx-auto -mt-8">
          <StyledImagesContainer>
            {logosRow2.map((partner, index) => (
              <img
              onContextMenu={(event) => handleRightClick(event, partner.url)} // Add right-click handler here

                src={partner.logoUrl}
                alt={`partner ${index + 6}`}
                className="partner-logo"
                key={index}
                onClick={() => {
                  // Only call handlePartnerClick if url is defined
                  if (partner.url) {
                    handlePartnerClick(partner.url);
                  }
                }} />
            ))}
          </StyledImagesContainer>
        </StyledContainer>
      </Reveal>
    </div>
  );
};

export default PartnersCard;
const StyledContainer = styled.div`
  ${tw`flex items-center justify-center `}
`;

const StyledImagesContainer = styled.div`
  ${tw`flex justify-center items-center `}
  flex-wrap: nowrap;

  .partner-logo {
    ${tw`rounded-full h-[11rem] w-[11rem] object-contain p-2 bg-white border border-gray-400 shadow-lg m-2`}
    transition: transform 0.3s ease-in-out;
    &:hover {

          margin-bottom: -5px; /* Adjust the negative margin to match the scaling factor */

      transform: scale(1.1);
    }
    cursor: pointer; // Add this line

  }

  @media (max-width: 768px) {
    flex-direction: column;
    .partner-logo {
      ${tw`m-2`} 
    }
  }
`;
